<template>
  <svg
    class="icon"
    :width="size"
    :height="size"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 38C29.9411 38 38 29.9411 38 20C38 10.0589 29.9411 2 20 2C10.0589 2 2 10.0589 2 20C2 29.9411 10.0589 38 20 38ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 11C11 10.4477 11.4477 10 12 10H28C28.5523 10 29 10.4477 29 11V29C29 29.5523 28.5523 30 28 30H12C11.4477 30 11 29.5523 11 29V11ZM13 12V28H27V12H13Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 20C15 19.4477 15.4477 19 16 19H24C24.5523 19 25 19.4477 25 20C25 20.5523 24.5523 21 24 21H16C15.4477 21 15 20.5523 15 20Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 24C15 23.4477 15.4477 23 16 23H20C20.5523 23 21 23.4477 21 24C21 24.5523 20.5523 25 20 25H16C15.4477 25 15 24.5523 15 24Z"
      :fill="color"
    />
    <path
      class="icon__fill"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 16C15 15.4477 15.4477 15 16 15H22C22.5523 15 23 15.4477 23 16C23 16.5523 22.5523 17 22 17H16C15.4477 17 15 16.5523 15 16Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconInfo",

  props: {
    // цвет иконки
    color: {
      type: String,
      default() {
        return this.$vuetify.theme.textPrimary;
      }
    },
    // размер
    size: {
      type: String,
      default: "40"
    }
  }
};
</script>
